<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import CmkMultitoneIcon from '@/components/CmkIcon/CmkMultitoneIcon.vue'
import type { OneColorIcons } from '@/components/CmkIcon/types'

defineProps<{
  icon: OneColorIcons
  text: string
}>()
</script>

<template>
  <button type="button" class="ai-assistant-question">
    <CmkMultitoneIcon
      class="ai-assistant-question__icon"
      :name="icon"
      primary-color="font"
      size="medium"
    />
    <span class="ai-assistant-question__text">{{ text }}</span>
  </button>
</template>

<style scoped>
.ai-assistant-question {
  display: flex;
  gap: var(--dimension-4);
  align-items: center;
  width: 100%;
  height: var(--dimension-10);
  margin: 0;
  padding: 0 calc(var(--dimension-6) - var(--border-width-1));
  border: var(--border-width-1) solid var(--border-color-muted);
  border-radius: var(--dimension-6);
  background: linear-gradient(to right, var(--ux-theme-4) 60%, var(--ux-theme-6));
  color: var(--font-color);
  font-size: var(--font-size-normal);
  font-weight: var(--font-weight-default);
  text-align: left;
  cursor: pointer;

  &:hover {
    border-color: var(--border-color-strong);
  }
}

.ai-assistant-question__icon {
  flex-shrink: 0;
}

.ai-assistant-question__text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
